export default __webpack_public_path__ + "static/media/le_touquet16.fd6ebeb7.jpg";